import React, { createContext, useContext, ReactNode, useState } from "react";

interface StepperContextProps {
  stepperProps: any;
  updateStepperProps: (newProps: any) => void;
}

const StepperContext = createContext<StepperContextProps | undefined>(
  undefined
);

interface StepperProviderProps {
  children: ReactNode;
}

export const StepperProvider: React.FC<StepperProviderProps> = ({
  children,
}) => {
  const [stepperProps, setStepperProps] = useState<any>({});

  const updateStepperProps = (newProps: any) => {
    setStepperProps((prevProps: any) => ({ ...prevProps, ...newProps }));
  };

  return (
    <StepperContext.Provider value={{ stepperProps, updateStepperProps }}>
      {children}
    </StepperContext.Provider>
  );
};

export const useStepper = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error("useStepper must be used within a StepperProvider");
  }
  return context;
};
